
import IconButton from "@mui/material/IconButton";
import { FC, ReactElement } from "react"
import { useLocation, useNavigate } from "react-router-dom";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import dayjs from "dayjs";

interface MeetingHeaderProps {
    meetingName?: string
    meetingDate?: Date
    primaryBtnText?: string
    disablePrimaryBtn?: boolean
    onPrimaryBtnClick?: () => void
    secondaryBtnText?: string
    disableSecondaryBtn?: boolean
    onSecondaryBtnClick?: () => void
    onBack?: () => void
    actionButtons?: ReactElement[]
    backRouteParent?: string
}

export const MeetingHeader: FC<MeetingHeaderProps> = (props: MeetingHeaderProps): ReactElement => {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', marginTop: 1, marginBottom: 1 }}>
            <IconButton onClick={() => props.onBack ? props.onBack() : ((props.backRouteParent && location.state?.blockPrevious) ? navigate(props.backRouteParent) : navigate(-1))}>
                <ChevronLeftIcon />
            </IconButton>
            <Typography variant="h6" sx={{ marginRight: 1 }}>
                {props.meetingName} {props.meetingDate ? ` | ${dayjs(props.meetingDate).format('DD MMMM YYYY')}` : ''}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {props.actionButtons?.map((button) => (
                <Box key={button?.key}>
                    {button}
                </Box>
            ))}
            {props.primaryBtnText &&
                <Button variant="outlined" onClick={props.onPrimaryBtnClick} disabled={props.disablePrimaryBtn}
                    sx={{
                        backgroundColor: 'rgba(0, 0, 0, 0.08)'
                    }}>
                    <Typography variant="button" sx={{
                        display: "block"
                    }}>
                        {props.primaryBtnText}
                    </Typography>
                </Button>
            }
            {props.secondaryBtnText &&
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', marginLeft: 1 }}>
                    <Typography sx={{ marginRight: 0 }}>
                        {props.secondaryBtnText}
                    </Typography>
                    <IconButton onClick={props.onSecondaryBtnClick}
                        disabled={props.disableSecondaryBtn}
                        sx={{
                            backgroundColor: 'rgba(0, 0, 0, 0.08)',
                            color: 'text.primary',
                            borderRadius: '50%',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.012)', // slightly darker on hover
                            },
                            '&.Mui-disabled': {
                                backgroundColor: 'action.disabledBackground',
                                color: 'action.disabled',
                            },
                        }}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
            }
        </Box>
    );
}

